<div [formGroup]="form">
    <mat-label class="mat-label-general" [ngbTooltip]="flangeMaterial_tooltip" placement="right" container="body" tooltipClass="custom-tooltip">
        <ng-container *transloco="let t; read: 'ENGINEERED_JOINT_PAGE.LABELS.CALC_INPUT'">
            {{ t(controlLabel) }}
        </ng-container>
    </mat-label>
    <!--tool-tip template start-->
    <ng-template #flangeMaterial_tooltip>
        <ng-container *transloco="let t; read: 'TOOLTIP.INFORMATE_CALC_LABELS'">
            <p>{{ t(controlLabel) }}</p>
        </ng-container>
    </ng-template>
    <!--tool-tip template end-->

    <div class="mat-select input-select" (click)="open(flangemodal)" [ngClass]="selectedValue ? '' : 'highLight'" [class.disable-div]="enable">
        <div cdk-overlay-origin="" class="mat-select-trigger">
            <div class="mat-select-value">
                <span class="mat-select-min-line">{{ selectedValue }}</span>
            </div>
            <div class="mat-select-arrow-wrapper">
                <div class="mat-select-arrow"><mat-icon>arrow_drop_down</mat-icon></div>
            </div>
        </div>
    </div>

    <ng-template #flangemodal let-modal>
        <div class="modal-header">
            <a class="close-icon" href="javascript:void()" ngbAutofocus (click)="modal.close('Ok click')">
                <i class="flaticon2-cross"></i>
            </a>

            <div class="row" style="width: 100%">
                <div class="col-md-7">
                    <h4 class="m-0 d-flex align-items-center h-100">
                        <!-- {{'Select ' + controlLabel}} -->
                        {{ 'STANDARD_FLANGE_PAGE.LABELS.SELECT' | transloco }}
                        <ng-container *transloco="let t; read: 'ENGINEERED_JOINT_PAGE.LABELS.CALC_INPUT'">{{ t(controlLabel) }} </ng-container>
                    </h4>
                </div>
                <div class="col-md-5">
                    <div class="search-wrapper">
                        <mat-form-field class="mat-filed" [floatLabel]="'never'">
                            <input
                                matInput
                                (keyup)="applyFilter($event)"
                                [formControl]="searchText"
                                placeholder="{{ 'INFORMATE_POPUP.LABELS.SEARCH' | transloco }}"
                                #input
                            />
                            <button mat-button matPrefix mat-icon-button class="search_btn">
                                <mat-icon>search</mat-icon>
                            </button>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-body informate-table-selection">
            <table mat-table [dataSource]="optionList" class="mat-elevation-z8">
                <ng-container matColumnDef="id" hidden="hidden">
                    <th mat-header-cell *matHeaderCellDef style="display: none"></th>
                    <td mat-cell *matCellDef="let element" style="display: none">{{ element.flangeMaterialId }}</td>
                </ng-container>

                <ng-container matColumnDef="alias" *ngIf="router.url == '/idms/plantmanager'">
                    <th mat-header-cell *matHeaderCellDef>Alias</th>

                    <td style="width: 25%" mat-cell *matCellDef="let element">{{ element?.alias?.alias }}</td>
                </ng-container>

                <!--Position Column-->
                <ng-container matColumnDef="position">
                    <th mat-header-cell *matHeaderCellDef>
                        <!-- Spec No. -->
                        {{ 'INFORMATE_POPUP.LABELS.SPEC_NO' | transloco }}
                    </th>
                    <td mat-cell style="width: 15%" *matCellDef="let element">{{ element.flangeMaterialSpecNo.specNo }}</td>
                </ng-container>
                <!--Name Column-->
                <ng-container matColumnDef="type">
                    <th mat-header-cell *matHeaderCellDef>
                        <!-- Type / Grade  -->
                        {{ 'INFORMATE_POPUP.LABELS.TYPE' | transloco }} / {{ 'INFORMATE_POPUP.LABELS.GRADE' | transloco }}
                    </th>
                    <td mat-cell style="width: 15%" *matCellDef="let element">{{ element.typeGrade }}</td>
                </ng-container>
                <!--Weight Column-->
                <ng-container matColumnDef="design">
                    <th mat-header-cell *matHeaderCellDef>
                        <!-- Allow Design -->
                        {{ 'INFORMATE_POPUP.LABELS.ALLOW_DESIGN' | transloco }}
                    </th>
                    <td mat-cell style="width: 15%" *matCellDef="let element">{{ element.alloyDesignUnsno }}</td>
                </ng-container>
                <!--Symbol Column-->
                <ng-container matColumnDef="composition">
                    <th mat-header-cell *matHeaderCellDef>
                        <!-- Nominal Composition -->
                        {{ 'INFORMATE_POPUP.LABELS.NOMINAL_COMPOSITION' | transloco }}
                    </th>
                    <td mat-cell style="width: 15%" *matCellDef="let element">{{ element.nominalComposition }}</td>
                </ng-container>
                <!--Symbol Column-->
                <ng-container matColumnDef="class">
                    <th mat-header-cell *matHeaderCellDef>
                        <!-- Class / Cond / Temper -->
                        {{ 'INFORMATE_POPUP.LABELS.CLASS' | transloco }} / {{ 'INFORMATE_POPUP.LABELS.COND' | transloco }} /
                        {{ 'INFORMATE_POPUP.LABELS.TEMPER' | transloco }}
                    </th>
                    <td mat-cell style="width: 15%" *matCellDef="let element">{{ element.classCondTemper }}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="selectItem(row)"></tr>
                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell error-message" colspan="5">No data matching the filter "{{ input.value }}"</td>
                </tr>
            </table>
            <mat-paginator #paginator [pageSize]="pageSize" [length]="totalSize" [pageIndex]="currentPage" (page)="pageEvent = handlePage($event)">
            </mat-paginator>
        </div>
    </ng-template>
</div>
